<template>
  <div>
    <div class="page-title">New People List</div>
    <Form
      v-if="form"
      v-model="form"
      :submit="create"
      btnText="Add People List"
    />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.lists.page";
export default {
  components: { Form },
  metaInfo() {
    return {
      title: "New People List",
    };
  },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.List.new();
      this.form = data;
    },
    async create() {
      await this.$api.List.create(this.form);
      this.$router.push("/widgets/lists");
    },
  },
};
</script>

<style></style>
